
import QuoteDown from "../../../assets/duotone/QuoteDown.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function QuoteDownIcon({ className, dataTestid = "QuoteDownIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <QuoteDown data-testid={dataTestid} className={classes} {...rest} />
  );
}
